import { AnimatedNumber } from '~/components/component-library/AnimatedNumber'
import { usePrivacyMode } from '~/hooks/usePrivacyMode'
import { HIDDEN_DECIMALS, HIDDEN_DIGITS } from '~/store/privacyModeStore'
import { splitDollarsAndCents } from '~/utils/currency'

export const LargeCurrencySmallCents = ({ amount }: { amount: number }) => {
  const { dollars, cents } = splitDollarsAndCents(amount)
  const isNegative = amount < 0
  const isPrivacyModeOn = usePrivacyMode()

  if (isPrivacyModeOn) {
    return (
      <div className="flex h-16 items-center justify-start font-medium">
        <span className="text-6xl leading-none">$</span>
        <span className="pl-1 text-3xl leading-none tracking-widest">
          {HIDDEN_DIGITS}
        </span>
        <span className="pb-2 text-xl leading-none tracking-widest">
          .{HIDDEN_DECIMALS}
        </span>
      </div>
    )
  }

  return (
    <div className="flex h-16 items-center justify-start font-medium">
      {isNegative && <span>-</span>}
      <AnimatedNumber
        value={dollars}
        className="text-6xl leading-none"
        format={{
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true,
          minimumIntegerDigits: 1,
        }}
      />
      <AnimatedNumber
        value={cents}
        className="pb-2 text-3xl leading-none"
        format={{ minimumIntegerDigits: 2 }}
        prefix="."
      />
    </div>
  )
}
